module.exports = __webpack_public_path__ + "img/sintoma em ponto de queda de folha 2.6e4594c6.webp";